import { render } from "./ItemForm.vue?vue&type=template&id=177d36e6&scoped=true&ts=true"
import script from "./ItemForm.vue?vue&type=script&lang=ts"
export * from "./ItemForm.vue?vue&type=script&lang=ts"

import "./ItemForm.vue?vue&type=style&index=0&id=177d36e6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177d36e6"]])

export default __exports__